import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Typography } from "@mui/material";
import ExpWithPicLeft from "../../ExpWithPicLeft";
import ExpWithPicRight from "../../ExpWithPicRight";

const ESG = () => {
  const { t, i18n } = useTranslation();
  return (
    <Box sx={{ textAlign: "center", pt: 10, width: 1, pb: 20 }}>
      <Typography variant="h4">ESG</Typography>
      <Typography
        sx={{
          width: 1 / 2,
          marginLeft: "auto",
          marginRight: "auto",
          pt: 1,
          lineHeight: "2.2em",
        }}
      >
        <strong>E</strong>nvironment · <strong>S</strong>ocial ·&nbsp;
        <strong>G</strong>overnance
      </Typography>
      <Box sx={{ display: "flex", justifyContent: "center", pt: 6 }}>
        <ExpWithPicLeft
          imgUrl="img/yaytg640233.jpg"
          title="Environment"
          content={t("Environment")}
        />
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", pt: 6 }}>
        <ExpWithPicRight
          imgUrl="https://images.unsplash.com/photo-1512418490979-92798cec1380?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
          title="Social"
          content={t("Social")}
        />
      </Box>
      <Box sx={{ display: "flex", justifyContent: "center", pt: 6 }}>
        <ExpWithPicLeft
          imgUrl="img/women.jpg"
          title="Governance"
          content={t("Governance")}
        />
      </Box>
    </Box>
  );
};

export default ESG;
